import React from "react";
import { ContractGroupModel } from "src/api/contractGroup/contractgroup-type";
import { CONTRACT_GROUP_STATUS_OPTIONS } from "../../contractgroup-constant";

type Props = {
  contractGroup: ContractGroupModel;
  contractSubjectInfo: {
    primaryOrgName: string;
    primaryCount: number;
    otherCount: number;
    totalCount: number;
  } | null;
};

const ContractGroupInfoForm = ({ contractGroup, contractSubjectInfo }: Props) => {
  return (
    <article className="contents-container__wrap-article">
      <div className="contents-container__sub-title">
        <h2>기본정보</h2>
      </div>
      <section className="contents-container__grid">
        <div className="contents-container__grid-index">
          <p>상태</p>
        </div>
        <div className="contents-container__grid-contents">
          <div className="minmax240">
            <span>{CONTRACT_GROUP_STATUS_OPTIONS.find((option) => option.value === contractGroup.groupStatus)?.label || "-"}</span>
          </div>
        </div>
      </section>
      <section className="contents-container__grid">
        <div className="contents-container__grid-index">
          <p>계약그룹명</p>
        </div>
        <div className="contents-container__grid-contents">
          <div className="">
            <span>{contractGroup.groupName}</span>
          </div>
        </div>
      </section>
      <section className="contents-container__grid">
        <div className="contents-container__grid-index">
          <p>계약자 (법인명/상호)</p>
        </div>
        <div className="contents-container__grid-contents">
          <div className="">
            {contractSubjectInfo ? (
              <span>
                {contractSubjectInfo.primaryOrgName}
                {contractSubjectInfo.otherCount > 0 && ` 외 ${contractSubjectInfo.otherCount}개`}
              </span>
            ) : (
              <span>-</span>
            )}
          </div>
        </div>
      </section>
    </article>
  );
};

export default ContractGroupInfoForm;
